<div class="block block-brands">
  <app-block-header [header]="'Nuestras Marcas'" colorText="text-primary" />

  @if (brands && brands.length > 0) {
  <owl-carousel-o
    class="marcas"
    [options]="carouselOptions"
    appOwlPreventClick
  >
    <ng-container *ngFor="let item of brands">
      <ng-template carouselSlide>
        <a
          href="/inicio/productos/todos?filter_MARCA={{
            item.brand | uppercase
          }}{{ getParamTiendaOficial(item.brand) }}"
        >
          <div style="width: 100px; aspect-ratio: 17/4; position: relative">
            <img [ngSrc]="imageUrl + '/' + item.image" alt="marcas" fill />
          </div>
        </a>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
  }
</div>
